import { tables } from '@configs/config.json';
import { RequestStatus } from '@store/types/request';
import { QcStatus } from '@services/ordertests/search';

export const defaultPagination = {
  numReturned: 0,
  numTotal: 0,
  offset: 0,
  limit: tables.pageSize,
};

export interface ITablePagination {
  numTotal: number;
  offset: number;
  limit: number;
  numReturned: number;
}

type asyncRequest = 'get' | 'post' | 'put' | 'delete';

export interface ITableSort {
  sortColumn: string;
  sortAscending: boolean;
}

export interface IBaseTableConfiguration {
  data: JSX.Element[];
  pagination: ITablePagination;
  requestStatus: RequestStatus;
}

export interface TableConfiguration {
  api: {
    [key: string]: {
      method: asyncRequest;
      route: string;
    };
  };
  filters: Object;
  pagination: ITablePagination;
  sortedBy: ITableSort;
  // columnNames: string[];
}
export interface TableReturnState {
  data: any[];
  status: number;
  sortedBy: ITableSort;
  dispatch: Function;
  exportData: Function;
  pagination: ITablePagination;
}

export interface ITablePagination {
  offset: number;
  limit: number;
  numTotal: number;
  numReturned: number;
}

export const filterTraverse = (obj: any, defaultValue: any) => {
  for (let k in obj) {
    if (obj[k] && typeof obj[k] === 'object') {
      filterTraverse(obj[k], defaultValue);
    } else {
      /**
       * FIX: If I understand this module correctly, it's meant to be
       * generic so it can be used for different data shapes. This
       * code piece is handling a specific use case.
       */
      if (k === 'qcStatus') {
        let qcStatus: QcStatus;
        switch (obj[k]) {
          case 'Cancelled':
            qcStatus = 'Cancelled';
            break;
          case 'Fail':
          case 'Failed':
            qcStatus = 'Failed';
            break;
          case 'Pass':
          case 'Passed':
            qcStatus = 'Passed';
            break;
          default:
            qcStatus = 'Pending';
        }
        obj[k] = qcStatus;
      }
      if (obj[k] === '') {
        obj[k] = null;
      }
    }
  }
  return obj;
};

export enum ResultsTableSortableColumnsEnum {
  orderNumber = 'OrderNumber',
  sampleName = 'SampleName',
  type = 'TestType',
  qcStatus = 'QCStatus',
  sampleId = 'SpecimenNumber',
  collectionDate = 'SpecimenCollectionDate',
  description = 'FlowCellId',
  patientId = 'ExternalSubjectId',
  resultsDate = 'Finished',
}

// const enumSortName = _.keys(enumResultsTableColumns)[
//   _.toArray(enumResultsTableColumns).indexOf(
//     sortedBy.sortColumn as enumResultsTableColumns
//   )
const sanitizeSort = (sortedBy: ITableSort) => {
  let cleanSortName;
  for (const [key, value] of Object.entries(ResultsTableSortableColumnsEnum)) {
    if (sortedBy.sortColumn === key) {
      cleanSortName = value;
    }
  }

  return {
    sortColumn: cleanSortName,
    sortAscending: sortedBy.sortAscending,
  };
};

export interface ITableRequestFormat {
  sortedBy: ITableSort;
  filters: Object;
  pagination: ITablePagination;
  headers?: HeadersInit;
}

export const formatRequest = ({
  sortedBy,
  filters,
  pagination: { offset, limit },
  headers = { 'Content-Type': 'application/json' },
}: ITableRequestFormat) => {
  const sanitizeFilters = filterTraverse(filters, null);
  const sanitizedSort = sanitizeSort(sortedBy);
  const params = JSON.stringify({
    ...sanitizeFilters,
    ...sanitizedSort,
    offset: offset,
    limit: limit,
  });

  return {
    init: {
      body: params,
      headers: {
        ...headers,
      },
    },
  };
};
